var map = {
	"./app.js": 5036,
	"./assignments.js": 4949,
	"./auth.js": 7037,
	"./componentUsage.js": 3301,
	"./components.js": 7660,
	"./doctorPatients.js": 8007,
	"./drafts.js": 9123,
	"./layout.js": 7581,
	"./medicines.js": 5681,
	"./modal.js": 1582,
	"./statistics.js": 7603,
	"./templates.js": 3835,
	"./therapyDetails.js": 9302,
	"./trans.js": 8121,
	"./userDetails.js": 6484
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 634;